import { Component } from '@angular/core';

@Component({
    selector: 'ca-key',
    templateUrl: './key.component.html',
    styleUrls: ['./key.component.scss'],
})
export class KeyComponent {}
